import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import CommonRoute from "../commonRoute";
import ApplyLeave from "../../main/leaves/applyLeave/page";
import LeaveSummary from "../../main/leaves/leaveSummary/page";

const leavesRoute = [
  {
    path: "/leaves",
    element: <CommonRoute />,
  },
  {
    path: "/leaves/apply",
    element: <ApplyLeave />,
  },
  {
    path: "/leaves/summary",
    element: <LeaveSummary />,
  },
];

export default function renderLeavesRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              path={route.path}
            >
            </ProtectedRoute>
          }
        >
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return leavesRoute.map((route) => renderRoute(route));
}

